import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function AddPayments() {
  const [amount, setAmount] = useState('');
  const [paymentDate, setPaymentDate] = useState(new Date().toISOString().split('T')[0]);
  const [userRole, setUserRole] = useState(""); // State to store user role
  const [organizations, setOrganizations] = useState([]); // List of organizations for Main Admin
  const [currentUser, setCurrentUser] = useState("");
  const [locations, setLocations] = useState([]);
  const [customers, setCustomers] = useState([]);
  const[selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedCustomerName, setSelectedCustomerName] = useState(null); // Stores customer name

  useEffect (() => {
    const fetchUserRoleAndOrganizations = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          toast.error("Authentication token is missing. Please log in again.");
          return;
        }

        // Fetch user role
        const userResponse = await axios.get(`${API_BASE_URL}/users/specific`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserRole(userResponse.data.role);

        // Fetch organizations if the user is a Main Admin
        if (userResponse.data.role === "Main Admin") {
          const orgResponse = await axios.get(`${API_BASE_URL}/organizations`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setOrganizations(orgResponse.data.organizations || []);
        }
      } catch (error) {
        console.error("Error fetching user role or organizations:", error);
        toast.error("Error fetching data");
      }
    };

    const fetchCurrentUser = async () => {
      const token = localStorage.getItem("token");
          if (!token) {
              toast.error("Authentication token missing. Please log in.");
              return;
          }
          try {
              const response = await axios.get(
                  `${API_BASE_URL}/users/specific`,
                  {
                  headers: { Authorization: `Bearer ${token}` },
                  }
          );
          const userData = response.data;
          setCurrentUser(userData);
          // Fetch locations and products based on role
          if (userData.role === "Main Admin") {
              fetchAllLocations();
          } else if (userData.role === "Company Admin") {
              fetchFilteredLocations(userData);
          }
          } catch (error) {
              console.error("Error fetching user data:", error);
              toast.error("Failed to fetch user data.");
          }
  
          fetchCurrentUser();
    };

    const fetchAllLocations = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
          `${API_BASE_URL}/locations`,
          {
              headers: { Authorization: `Bearer ${token}` },
          }
      );
      setLocations(response.data.locations);
      };

      const fetchFilteredLocations = async () => {
      const token = localStorage.getItem("token");
      const response = await axios.get(
          `${API_BASE_URL}/products/filtered-locations`,
          {
          headers: { Authorization: `Bearer ${token}` },
          }
      );
      setLocations(response.data.locations);
  };

  const fetchCustomers = async () => {
    const token = localStorage.getItem("token");
    const response = await axios.get(
      `${API_BASE_URL}/customers/`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );


    setCustomers(response.data.customers);
  };
    fetchUserRoleAndOrganizations();  
    fetchCustomers();
  }, [userRole]);

  // Handle form submission
  const handleAddPayment = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("Authentication token is missing. Please log in again.");
        return;
      }

      // Create new payment receipt object
      const newPayment = {
        payment_date: paymentDate,
        customer_id: selectedCustomer,
        amount: parseFloat(amount),
        invoices: [],
      };

      // Send POST request to add payment receipt
      const response = await axios.post(
        `${API_BASE_URL}/paymentReceipts/add`,
        newPayment,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 201) {
        toast.success("Payment receipt added successfully");

        // ✅ Clear form fields after successful submission
        setAmount('');
        setPaymentDate(new Date().toISOString().split('T')[0]);
        setSelectedCustomer(null);
        setSelectedCustomerName(null);
      }
    } catch (error) {
      console.error("Error adding payment receipt:", error);
      toast.error("Failed to add payment receipt");
    }
  };

  const customCustomerIDSelect = (customerOptions, selectedCustomer, setSelectedCustomer, setSelectedCustomerName) => {
    return (
      <Select
        options={customerOptions}
        getOptionLabel={(e) => e.customer_code} // Show customer ID in dropdown
        getOptionValue={(e) => e._id} // Use _id as value
        isSearchable={true} // Enable search functionality
        placeholder="Search by Customer ID"
        className="w-full"
        value={customerOptions.find((option) => option._id === selectedCustomer) || null}
        onChange={(selectedOption) => {
          setSelectedCustomer(selectedOption?._id); // Set selected customer ID
          setSelectedCustomerName(selectedOption?.customer_name); // Auto-fill the customer name
        }}
      />
    );
  };
  
  const customCustomerNameSelect = (customerOptions, selectedCustomerName, setSelectedCustomerName, setSelectedCustomer) => {
    return (
      <Select
        options={customerOptions}
        getOptionLabel={(e) => e.customer_name} // Show customer name in dropdown
        getOptionValue={(e) => e._id} // Use _id as value
        isSearchable={true} // Enable search functionality
        placeholder="Search by Customer Name"
        className="w-full"
        value={customerOptions.find((option) => option.customer_name === selectedCustomerName) || null}
        onChange={(selectedOption) => {
          setSelectedCustomer(selectedOption?._id); // Auto-fill customer ID
          setSelectedCustomerName(selectedOption?.customer_name); // Set selected customer name
        }}
      />
    );
  }

  return (
    <div className="container mx-auto p-6">
      <div className="bg-white rounded-lg shadow-lg p-6 mt-4">
        <h2 className="text-2xl font-bold text-green-700 mb-6">
          Add Receipt
        </h2>
        <div className="grid grid-cols-2 gap-6 mb-6">
        <div>
            <label className="block text-gray-700 mb-2">Customer ID</label>
            {customCustomerIDSelect(customers, selectedCustomer, setSelectedCustomer, setSelectedCustomerName)}
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Customer</label>
            {customCustomerNameSelect(customers, selectedCustomerName, setSelectedCustomerName, setSelectedCustomer)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-6 mb-6">
          
          <div>
              <label className="block text-gray-700 mb-2">Amount (LKR)</label>
              <input
                type="number"
                className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Enter payment amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
          </div>
          <div>
            <label className="block text-gray-700 mb-2">Payment Date</label>
            <input
              type="date"
              className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={paymentDate}
              onChange={(e) => setPaymentDate(e.target.value)}
            />
          </div>
        </div>
        <div className="flex justify-end mt-6">
          <button
            className="bg-green-700 text-white px-6 py-3 rounded-lg hover:bg-blue-600"
            onClick={handleAddPayment}
          >
            Add Payment
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddPayments;
    